import '@babel/polyfill';

import Vue from 'vue';

import VueCookies from 'vue-cookies';
import VeeValidate, { Validator } from 'vee-validate';
import VCalendar from 'v-calendar';
import VueYoutube from 'vue-youtube';
import VModal from 'vue-js-modal';
import VueLazyload from 'vue-lazyload';
import VueAnalytics from 'vue-analytics';

import AOS from 'aos';
// import naver from 'vue-naver-maps';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import axios from '@/plugins/axios';
import numeral from '@/plugins/numeral';
import moment from '@/plugins/moment';
// import lodash from '@/plugins/lodash';
import hangul from '@/plugins/hangul';

import '@/directives/lazy-loading-background';

import 'aos/dist/aos.css';
// import 'bootstrap';
// import '@/assets/bootstrap/css/bootstrap.min.css';
import 'nprogress/nprogress.css';
import 'video.js/dist/video-js.css';

Vue.config.productionTip = false;

Vue.use(VueLazyload);
Vue.use(VModal);
Vue.use(VueCookies);
Vue.use(axios);
Vue.use(numeral);
Vue.use(moment);
// Vue.use(lodash);
Vue.use(hangul);
Vue.use(VueAnalytics, {
  id: 'UA-156344766-1',
  router,
});

Vue.prototype.publicPath = process.env.BASE_URL;
Vue.prototype.isDevelop = process.env.NODE_ENV !== 'production';

Validator.extend('mobile', {
  getMessage: (field) => `${field} should include lower-case,
  numeric digit, special chracter($@$!%*#?&).`,
  validate: (value) => /^01(?:0|1|[6-9])[.-]?(\d{3}|\d{4})[.-]?(\d{4})$/.test(value),
});

AOS.init();
Vue.use(VueYoutube);
Vue.use(VeeValidate, {
  events: 'input|blur',
});
// Vue.component('date-picker', DatePicker);
Vue.use(VCalendar, {
  popoverVisibility: 'focus',
  masks: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['YYYY-MM-DD'], // Only for `v-date-picker`
    dayPopover: 'YYYY-MM-DD', // Only for `v-date-picker`
    data: ['YYYY-MM-DD'], // For attribute dates
  },
});
// Vue.use(naver, {
//   clientID: '2yud92t926',
//   useGovAPI: false,
//   subModules: '',
// });

Vue.filter('nl2br', (value) => value.split('\n').join('<br>'));
Vue.filter('moment', (value, format = 'YYYY-MM-DD') => Vue.moment(value).format(format));
Vue.filter('plainText', (value) => value.replace(/(<([^>]+)>)/ig, ''));
Vue.filter('normalize', (v) => (v.normalize ? v.normalize('NFC') : v));

Vue.mixin({
  computed: {
    isMobile() {
      return window.innerWidth < 758;
    },
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
